import { CrimePoint } from '@/models/CrimePoint';
import Vue from 'vue';
import Vuex from 'vuex';
import RemaxService from '../../services/RemaxService';

Vue.use(Vuex);

export interface LayerState {
    isHeatLayersInit: boolean;
    isCrimeLayersInit: boolean;
    heatmapData: number[][] | null;
    selectedCrime: CrimePoint | null;
}

export default {
    state: {
        isHeatLayersInit: false,
        isCrimeLayersInit: false,
        heatmapData: null,
        selectedCrime: null,
    } as LayerState,
    mutations: {
        SET_HEAT_LAYERS_INIT(state: LayerState, isInit: boolean) {
            state.isHeatLayersInit = isInit;
        },
        SET_CRIME_LAYERS_INIT(state: LayerState, isInit: boolean) {
            state.isCrimeLayersInit = isInit;
        },
        SET_HEATMAP_DATA(state: LayerState, data: number[][]) {
            state.heatmapData = data;
        },
        SET_SELECTED_CRIME(state: LayerState, crime: CrimePoint | null) {
            state.selectedCrime = crime;
        },
    },
    actions: {
        initHeatmapLayer(context: any) {
            console.log('initHeatmapLayer');
            RemaxService.getSoldPoints()
            .then((response) => {
                // if (response && response.error) {
                //     console.error(response.error);
                //     context.dispatch('notify', response.error);
                // }
                // Logger.writeLog("GetSoldPoints- Data Loaded.");

                // Adding weight values for the heatmap
                for (let i = 0; i < response.data.length; i++) {
                    response.data[i].push(1);
                }
                console.log(response.data);
                context.commit('SET_HEATMAP_DATA', response.data);
                context.commit('SET_HEAT_LAYERS_INIT', true);
                context.dispatch('heatmapDataLoaded', response.data);
            })
            .catch((error) => {
                console.error(error);
                context.dispatch('notify', error);
            });
        },
        initCrimeLayer(context: any) {
            context.commit('SET_CRIME_LAYERS_INIT', true);
        },
        heatmapDataLoaded(context: any) {
            //
        },
        changeSelectedCrime(context: any, crime: CrimePoint) {
            console.log(crime);
            context.commit('SET_SELECTED_CRIME', crime);
            // TODO
            // _clearWalkData();
        },
        clearSelectedCrime(context: any) {
            context.commit('SET_SELECTED_CRIME', null);
        },
        // EVENT_show_Crime_dialog
        showCrimeDialog(context: any, crime: CrimePoint) {
            //
        },
    },
};
